<div class="select-container">
  <label class="select-label">{{ labelText }}</label>
  <div class="select">
    <input
      type="text"
      [disabled]="disabled"
      class="select-component"
      [formControl]="myControl"
      [required]="required"
      [ngClass]="{ input__invalid: submitted && !myControl.value }"
      matInput
      [matAutocomplete]="auto"
      (keydown.enter)="$event.preventDefault()"
      (blur)="onBlur()"
    />
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option
        *ngFor="let option of filteredOptions | async"
        [value]="option.value"
        (click)="getValue()"
        (keydown)="getValueOnKeyDown($event)"
      >
        {{ option.text }}
      </mat-option>
    </mat-autocomplete>
    <mat-icon>search</mat-icon>
  </div>
  <label
    class="warning-label"
    *ngIf="submitted && !myControl.value && !labelWarningGenericText"
  >
    Ingrese su {{ labelText }}
  </label>
  <label
    class="warning-label"
    *ngIf="submitted && !myControl.value && labelWarningGenericText"
  >
    Seleccione una opcion
  </label>
</div>
